{
    "PageTitle_auth": "Autenticação",
    "NAME": "Router",
    "PageTitle_presence": "Presença",
    "PageTitle_changePassword": "Alterar a senha",
    "PageTitle_forgotPassword": "Esqueceu sua senha",
    "PageTitle_changeLanguage": "Alterar idioma",
    "PageTitle_resetPassword": "Redefinir senha",
    "PageTitle_termsAndConditions": "Termos e Condições",
    "PageTitle_cookiePolicy": "Política de Cookies",
    "PageTitle_privacyPolicy": "política de Privacidade",
    "PageTitle_mfa": "Autenticação multifator",
    "PageTitle_teamsAuth": "Autenticação de equipes",
    "PageTitle_insights": "Percepções",
    "PageTitle_crmIntegration": "Integração de CRM",
    "PageTitle_changeUserAgent": "Alterar agente do usuário",
    "PageTitle_clientConfiguration": "Configuração do cliente",
    "PageTitle_CRMConfiguration": "Configuração de CRM"
}